import { BufferedObservable } from '../tools/observable';
import { mockable } from '../tools/mockable';
import { initFetchObservable } from '../browser/fetchObservable';
import { initXhrObservable } from '../browser/xhrObservable';
import { ConsoleApiName } from '../tools/display';
import { addTelemetryDebug } from './telemetry';
import { trackRuntimeError } from './error/trackRuntimeError';
import { initConsoleObservable } from './console/consoleObservable';
const BUFFER_LIMIT = 500;
export function startBufferingData() {
    const observable = new BufferedObservable(BUFFER_LIMIT, (count) => {
        // monitor-until: 2026-10-14
        addTelemetryDebug('Early data collection dropped data on unbuffer', {
            count,
        });
    });
    const subscriptions = [];
    function subscribe(type, source) {
        subscriptions.push(source.subscribe((data) => {
            observable.notify({ type, data });
        }));
    }
    subscribe(0 /* BufferedDataType.RUNTIME_ERROR */, mockable(trackRuntimeError)());
    subscribe(1 /* BufferedDataType.FETCH */, initFetchObservable());
    subscribe(2 /* BufferedDataType.XHR */, initXhrObservable({ allowUntrustedEvents: true }));
    subscribe(3 /* BufferedDataType.CONSOLE */, initConsoleObservable(Object.values(ConsoleApiName)));
    return {
        observable,
        stop: () => subscriptions.forEach((subscription) => subscription.unsubscribe()),
    };
}
//# sourceMappingURL=bufferedData.js.map